import React from 'react';
import Logo from '../../assets/icons/logo-dev-white.svg';
import SidebarLink from './SidebarLink';
import { sidebarLinks } from '../../utils/constants';
import './Sidebar.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { UserRoleEnum } from '../../types/apiGeneratedTypes';
import { toggleSidebarCollapsed } from '../../store/pageSlice';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/arrow-right.svg';
import UserCard from '../Header/UserCard';
import UserProfileModal from '../Header/UserProfile';

const isSuperAdminUser = (admin: RootState['admin']['admin']) =>
  admin.role === UserRoleEnum.SuperAdmin && admin.is_super_admin === true;

const Sidebar = () => {
  const [isUserProfileModalOpen, setIsUserProfileModalOpen] =
      React.useState<boolean>(false);
  const dispatch = useDispatch();
  const adminInfo = useSelector((state: RootState) => state.admin);
  const currentPage = useSelector((state: RootState) => state.page);
  const isCollapsed = currentPage.sidebarCollapsed;
  let renderedSidebarLinks = sidebarLinks;

  // Hide superadmin-only links for non-superadmins.
  if (!isSuperAdminUser(adminInfo.admin)) {
    renderedSidebarLinks = renderedSidebarLinks.filter(
      (l) =>
        l.link !== '/' &&
        l.link !== '/scheduler' &&
        l.link !== '/audit-logs' &&
        l.link !== '/body-systems' &&
        l.link !== '/marketing-cms' &&
        l.link !== '/doctors' &&
        l.link !== '/nutritionists' &&
        l.link !== '/clinics' &&
        l.link !== '/teams' &&
        l.link !== '/cv-dashboard'
    );
  }

  if (adminInfo.admin.role === UserRoleEnum.Doctor) {
    renderedSidebarLinks = renderedSidebarLinks.filter(
      (link) =>
        link.link === '/members' ||
        link.link === '/alerts' ||
        link.link === '/chat' ||
        link.link === '/appointments'
    );
  } else if (adminInfo.admin.role === UserRoleEnum.Nutritionist) {
    renderedSidebarLinks = renderedSidebarLinks.filter(
      (link) =>
        link.link === '/members' ||
        link.link === '/alerts' ||
        link.link === '/appointments'
    );
  }

  if (currentPage.showSidebar === false) return null;

  const onToggleClick = () => {
    dispatch(toggleSidebarCollapsed());
  };

  return (
    <div className={`sidebar-wrapper${isCollapsed ? ' collapsed' : ''}`}>
      <button
        type='button'
        className='sidebar-toggle-btn'
        onClick={onToggleClick}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <ArrowRightIcon />
      </button>
      <div className='sidebar'>
        <div className='sidebar-logo'>
          <img
            src={Logo}
            className='leftAlign'
            height={34}
            alt='main logo'
          />
        </div>
        
        <UserProfileModal
          isOpen={isUserProfileModalOpen}
          onClose={() => setIsUserProfileModalOpen(false)}
        />

        {!isCollapsed && (
          <>
            <div>
              <UserCard />
            </div>
            <div className='links-container'>
              {renderedSidebarLinks.map((sidebarLink) => (
                <SidebarLink
                  link={sidebarLink.link}
                  title={sidebarLink.title}
                  icon={sidebarLink.icon}
                  activeIcon={sidebarLink.activeIcon}
                  key={sidebarLink.link}
                  showCount={sidebarLink.showCount}
                />
              ))}
            </div>
            <div className='sidebar-footer'>
              <a href='/privacy-policy'>Privacy Policy</a>
              <a href='/terms-conditions'>Terms and Conditions</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
